import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { stringIsNotEmpty } from '../../utils/content-formatting';

const ResponsiveImage = ({
  image,
  mobileW,
  desktopW,
  fit,
  focusArea,
  progressive,
  mobileH,
  desktopH,
  className,
  presentational = false,
}) => {
  if (!mobileW || !desktopW || !image) return null;
  const { description, file } = image;
  const { url } = file;

  // Use the https://www.contentful.com/developers/docs/references/images-api/ to construct a mobile and desktop image
  const params = {
    fl: progressive ? 'progressive' : undefined,
    fit,
    f: focusArea,
    q: 95,
  };
  const mobileSize = {
    h: mobileH,
    w: mobileW,
  };
  const desktopSize = {
    h: desktopH,
    w: desktopW,
  };

  const mobileParams = queryString.stringify({ ...params, ...mobileSize });
  const desktopParams = queryString.stringify({ ...params, ...desktopSize });

  return (
    <picture>
      <source
        srcSet={`${url}?fm=avif&${mobileParams} 480w,
                 ${url}?fm=avif&${desktopParams}`}
        type="image/avif"
      />

      <source
        srcSet={`${url}?fm=webp&${mobileParams} 480w,
                 ${url}?fm=webp&${desktopParams}`}
        type="image/webp"
      />

      <img
        className={className}
        loading={process.env.VRT ? 'eager' : 'lazy'}
        srcSet={`${url}?${mobileParams} 480w,
        ${url}?${desktopParams}`}
        alt={
          !presentational && stringIsNotEmpty(description) ? description : ''
        }
        src={`${url}?${desktopParams}`}
      />
    </picture>
  );
};
export default ResponsiveImage;

ResponsiveImage.propTypes = {
  mobileW: PropTypes.number.isRequired,
  mobileH: PropTypes.number,
  desktopW: PropTypes.number.isRequired,
  desktopH: PropTypes.number,
  fit: PropTypes.oneOf(['pad', 'fill', 'scale', 'crop', 'thumb']),
  focusArea: PropTypes.string,
  progressive: PropTypes.bool,
  className: PropTypes.string,
  presentational: PropTypes.bool,
  image: PropTypes.shape({
    description: PropTypes.string.isRequired,
    title: PropTypes.string,
    file: PropTypes.shape({
      contentType: PropTypes.string,
      fileName: PropTypes.string,
      url: PropTypes.string.isRequired,
    }).isRequired,
  }),
};
